export const programPromotionCardStyle = (
  phoneScreen: boolean,
  isInCarousel: boolean,
  isPreEffective: boolean,
  ctaValue?: string
) => ({
  'abyss-card-root': {
    display: 'flex',
    width: phoneScreen ? (isInCarousel ? 'calc(100% - 8px)' : '100%') : '384px',
    height: '203px',
    padding: '24px 24px 32px 24px',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '16px',
    borderRadius: '8px',
    border: '1px solid #E5E5E6',
    background: '#FFF',
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.05)',
    marginTop: '0 !important',
    marginBottom: '0 !important',
    marginRight: '0',
    cursor: isPreEffective || !ctaValue ? 'not-allowed' : 'pointer',
    opacity: isPreEffective || !ctaValue ? 0.6 : 1,
    overflow: 'visible',
  },
  '& + .abyss-card-root': {
    marginTop: '0 !important',
  },
});

export const programPromotionSlideStyle = (phoneScreen: boolean) => ({
  'abyss-slide-container': {
    marginLeft: 0,
    marginRight: 0,
    background: 'transparent',
    width: phoneScreen ? '100%' : '400px',
    minWidth: phoneScreen ? '100%' : '400px',
    maxWidth: phoneScreen ? '100%' : '400px',
    flex: '0 0 auto',
  },
});

export const programPromotionDescriptionStyle = {
  width: '100%',
  height: '39px',
  lineHeight: '20px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  flexShrink: 0,
  alignSelf: 'stretch',
};
